import React, { Fragment, useMemo } from "react";

import { Button } from "devextreme-react/button";
import { LoadIndicator } from "devextreme-react/load-indicator";
import Tabs from "devextreme-react/tabs";
import { Case, CaseElse, Switch } from "react-context-switch";
import { useTranslation } from "react-i18next";

import { useInsiderGate } from "@app/contexts";
import { setUiDrawer, useAppDispatch } from "@app/state";
import * as appConst from "@app/state/constants";
import {
  forwardPersitence,
  imperativePersist,
} from "@app/stateCommon/idbAdapters";
import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { sfxInLogout } from "@app/statefx/xThunks/login";
import { setLoaderPopup } from "@app/statefx/xThunks/ui-persist";
import { fxRectSelectedTab } from "@app/statefx/xThunks/uiDrawer";

import "./wh3.scss";

export const IJGHeader = () => {
  const { toggleDrawer } = useInsiderGate();
  const { t } = useTranslation();
  const dispatch = useFxDispatch();
  const sagaDispatch = useAppDispatch();
  const tabs = useFxSelector(schema.uiJGBrowserHeader.select);
  const showingPopup = useFxSelector(schema.loaderPopup.select);
  const lock = useFxSelector(schema.lock.select);
  const isBooting = (lock || "").startsWith("$:bootup");

  const bootAction_ = useFxSelector(schema.loaderBootText.select);
  const bootAction = useMemo(
    () => (bootAction_.includes("cache") ? "CACHE" : "DATA"),
    [bootAction_]
  );

  // const progress = useFxSelector(schema.loaderBootProgress.select);

  const selectedTab = tabs.tabSelected;

  const theTabs = useMemo(
    () =>
      tabs.tabsAvailable.map((x) => {
        switch (x) {
          case appConst.EMenuCmdTab.CMD_BGIM_CLIENTS:
            return { id: x, text: t("Clients") };
          case appConst.EMenuCmdTab.CMD_BGIM_MESSAGES:
            return { id: x, text: t("Messages") };
          case appConst.EMenuCmdTab.CMD_BGIM_INVOICE_TRACKING:
            return { id: x, text: t("Invoice Tracking") };
          case appConst.EMenuCmdTab.CMD_BGIM_INVOICE:
            return { id: x, text: t("Invoice") };
          case appConst.EMenuCmdTab.CMD_BGIM_REPORTS:
            return { id: x, text: t("Reports") };
          case appConst.EMenuCmdTab.CMD_BGIM_INVOICE_SERIES:
            return { id: x, text: t("Invoice Series") };
          case appConst.EMenuCmdTab.CMD_BGIM_LICENSE:
            return { id: x, text: t("License") };
          case appConst.EMenuCmdTab.CMD_BGIM_OAUTH2:
            return { id: x, text: t("OAuth2") };
          case appConst.EMenuCmdTab.CMD_BGIM_EMITENT:
            return { id: x, text: t("Emitent") };
          case appConst.EMenuCmdTab.CMD_BGIM_ACCOUNTS:
            return { id: x, text: t("Accounts") };
          case appConst.EMenuCmdTab.CMD_BGIM_INVOICE_OVERALL:
            return { id: x, text: t("Invoice Overall") };
          case appConst.EMenuCmdTab.CMD_BGIM_USERCONFIG:
            return { id: x, text: t("User Config") };
          default:
            break;
        }
      }),
    [tabs]
  );

  const tabsIdx = useMemo(
    () =>
      theTabs.reduce((acc, tab) => {
        const { id } = tab || {};
        acc[id] = tab;
        return acc;
      }, {}),
    [theTabs]
  );

  const theCurrentTabId = tabsIdx[selectedTab]?.id;
  const onItemChange = (e) => {
    dispatch(fxRectSelectedTab(e.itemData.id as appConst.EMenuCmdTab));
  };
  const indicatorclick = () => {
    dispatch(setLoaderPopup(!showingPopup));
  };
  const exitInsider = async () => {
    imperativePersist();
    sagaDispatch(setUiDrawer({ currentPage: "profile" }));
    toggleDrawer(false);
    dispatch(sfxInLogout());
  };
  return (
    <Fragment>
      <div id={"HeaderTitle"}>{"Jurnal Gold"}</div>
      <Tabs
        id="HeaderTabs2"
        keyExpr={"id"}
        height={appConst.SIZES.jgHeaderHeight}
        visible={theTabs.length > 0}
        className="dx-swatch-builder-dark"
        dataSource={theTabs}
        onItemClick={onItemChange}
        defaultSelectedItemKeys={[0]}
        selectedItemKeys={[theCurrentTabId]}
      />
      <div
        className={`small-inicator rigt-top-button`}
        style={{ position: "absolute" }}
        onClick={indicatorclick}
      >
        <Switch value={isBooting}>
          <Case when={true}>
            <LoadIndicator
              className={`small-inicator rigt-top ${bootAction}`}
              height={14}
              width={14}
            />
          </Case>
          <CaseElse>
            <Button
              height={appConst.SIZES.jgHeaderHeight - 4}
              width={appConst.SIZES.jgHeaderHeight - 4}
              style={{ padding: "0px" }}
              className={"insiderclose dx-close-button"}
              icon={
                '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 12L7 7m5 5l5 5m-5-5l5-5m-5 5l-5 5"/></svg>'
              }
              type="default"
              stylingMode={"outlined"}
              onClick={exitInsider}
            ></Button>
          </CaseElse>
        </Switch>
      </div>
    </Fragment>
  );
};
